export default function auth ({ next, store, router, to }) {
  if (!store.getters['Auth/loggedIn']) {
    // Don't save error/unauthorized pages as the intended destination
    const skipRoutes = ['unauthorized', 'login']
    if (!skipRoutes.includes(to.name)) {
      store.dispatch('Auth/setIntended', to.name)
    }
    return router.push({ name: 'login' })
  }

  return next()
}
